export default "images/navigation.png";